import './styles.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ThemeProvider } from '@/components/theme/theme-provider'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { installFavicon } from '@/lib/favicon'
import { createQueryClient } from '@/lib/query-client'
import { createAppRouter } from '@/router'

installFavicon()

const queryClient = createQueryClient()
const router = createAppRouter(queryClient)

const container = document.getElementById('root')

if (container === null) {
  // Falhar alto é melhor do que uma tela branca silenciosa.
  throw new Error('Elemento #root não encontrado no index.html.')
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider delayDuration={200} skipDelayDuration={300}>
          <RouterProvider router={router} />
          <Toaster />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
